// src/pages/ExplorePage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/layout/BottomNav';

const ExplorePage = () => {
  const navigate = useNavigate();
  return (
    <div className="page" style={{ background: 'var(--cream)', padding: '52px 20px 20px' }}>
      <div style={{ fontSize: 28, fontWeight: 800, color: 'var(--ink)', marginBottom: 8, letterSpacing: '-0.3px' }}>Explore</div>
      <div style={{ fontSize: 14, color: 'var(--muted)', fontWeight: 500, marginBottom: 24 }}>Find events in another town or county</div>
      <button onClick={() => navigate('/county')} style={{ width: '100%', background: 'var(--sage-deep)', color: 'white', border: 'none', borderRadius: 16, padding: 17, fontSize: 16, fontWeight: 700, fontFamily: 'Nunito', cursor: 'pointer' }}>
        Browse by county →
      </button>
      <BottomNav />
    </div>
  );
};

export default ExplorePage;
